/**
 * Keeps the sort accordion's "(Current option)" heading label in sync with
 * the selected radio. The fetch itself is handled by
 * initCollectionSearchFilters — the radios sit inside [data-filter-form] and
 * are named sort_by, so the form's input listener and FormData serialisation
 * pick them up like any other facet.
 *
 * The label is only updated on user change events: renderFilters deliberately
 * never re-renders the sort accordion (it syncs [data-facet-filter] inputs
 * only), so the last change always reflects the current state. Revisit this
 * if renderFilters is ever extended to touch the sort panel.
 */
const initSortRadios = () => {
  const filtersContainerEl = document.querySelector('[data-filters-container]');
  if (!filtersContainerEl) return;

  const sortLabelEl = filtersContainerEl.querySelector('[data-sort-by-label]');
  if (!sortLabelEl) return;

  filtersContainerEl.addEventListener('change', (event) => {
    const radioEl = event.target.closest('[data-sort-radio]');
    if (!radioEl) return;
    sortLabelEl.textContent = `(${radioEl.dataset.sortName})`;
  });
};

export default initSortRadios;
